export interface IImpersonatedAuthenticationResponseModelData {
    result: ImpersonatedAuthenticationResponseModel;
  }
  
  export class ImpersonatedAuthenticationResponseModel {
    accessToken: string;
    encryptedAccessToken: string;
    expireInSeconds: number;
  }
  
  export interface IImpersonationResponseModelData {
    result: ImpersonationResponseModel;
  }
  
  
  export class ImpersonationResponseModel {
    impersonationToken: string;
    tenancyName: string;
  }
  

export class ImpersonateInput {
    tenantId!: number | undefined;
    userId!: number | undefined;

    constructor(tenantId: number | undefined, userId: number) {
        this.tenantId = tenantId;
        this.userId = userId;
    }
}

export class ImpersonateOutput {
    impersonationToken!: string | undefined;
    tenancyName!: string | undefined;
}